import {
  createReducer,
  defaultListInitialState,
  defaultGetReducer
} from '../utils';

import { GET_STATIC_PAGES } from '../constants/staticPages';

const staticPagesInitialState = defaultListInitialState();
const staticPages = createReducer(staticPagesInitialState, {
  [GET_STATIC_PAGES]: defaultGetReducer
});

export default staticPages;



// WEBPACK FOOTER //
// ./src/reducers/staticPages.js